export class MissionTimeSlot {
    dates: Date[] = [];
    start_time: Date = new Date();
    end_time: Date = new Date();
    has_break = false;
    after_break_start_time: Date = new Date();
    after_break_end_time: Date = new Date();

    constructor() {
        this.dates = [];
        this.start_time.setHours(8, 0, 0);
        this.end_time.setHours(18, 0, 0);
        this.after_break_start_time.setHours(12, 0, 0);
        this.after_break_end_time.setHours(13, 0, 0);
    }
}
